<ms-split-navigation-panel [title]="settingsPanelTitle" [navItems]="settingsNavItems"
    (tabChanged)="onSettingsTabChanged($event)">

    <ng-template msNavContent="payment-methods">
        @if (user()) {
        <ms-user-payment-methods [user]="user()!">
        </ms-user-payment-methods>
        }
    </ng-template>

</ms-split-navigation-panel>
